import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import type { AttachmentRef } from './attachments-api'

interface AttachmentPreviewModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  attachment: AttachmentRef | null
}

export function AttachmentPreviewModal({ open, onOpenChange, attachment }: AttachmentPreviewModalProps) {
  if (!attachment) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>{attachment.filename}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span className="rounded bg-muted px-2 py-0.5 font-mono">{attachment.mime}</span>
            <span>{attachment.kind}</span>
          </div>
          {attachment.kind === 'image' && attachment.storage_url && (
            <img
              src={attachment.storage_url}
              alt={attachment.filename}
              className="max-h-[480px] w-full rounded border border-border object-contain"
            />
          )}
          {attachment.transcript && (
            <div>
              <h4 className="mb-1 text-sm font-semibold">Transkript</h4>
              <p className="whitespace-pre-wrap rounded bg-muted/40 p-3 text-sm">{attachment.transcript}</p>
            </div>
          )}
          {attachment.extracted_text && (
            <div>
              <h4 className="mb-1 text-sm font-semibold">Extrahierter Text</h4>
              <pre className="max-h-[300px] overflow-y-auto whitespace-pre-wrap rounded bg-muted/40 p-3 font-mono text-[12px]">
                {attachment.extracted_text.slice(0, 5000)}
                {attachment.extracted_text.length > 5000 ? '\n…' : ''}
              </pre>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
